export const CONTACT = {
  phoneDisplay: "0 (532) 499 49 01",
  phoneHref: "tel:+905324994901",
  whatsappDisplay: "0 (532) 499 49 01",
  whatsappNumber: "905324994901",
  email: "info@sistemliotomotiv.com",
  instagram: "https://www.instagram.com/sistemliotomotivadana",
  instagramHandle: "@sistemliotomotivadana",
  address: "Onur Mahallesi, 45166. Sk. No:4, 01100 Seyhan / Adana",
  mapsUrl: "https://maps.app.goo.gl/4CeS1VcSAVi54XGA6",
  mapEmbed:
    "https://maps.google.com/maps?q=S%C4%B0STEML%C4%B0%20OTOMOT%C4%B0V%2C%20Onur%2C%2045166.%20Sk.%20NO%3A4%2C%2001100%20Seyhan%2FAdana&hl=tr&z=17&output=embed",
};

export const waLink = (text) =>
  `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(text)}`;

export const DEFAULT_WA_MESSAGE =
  "Merhaba Sistemli Otomotiv, aracımın kaporta/boya/mekanik onarımı için bilgi ve fiyat almak istiyorum.";

export const STATS = [
  { value: "1.026 m²", label: "Kapalı Atölye Alanı" },
  { value: "9", label: "Uzmanlık Hizmeti" },
  { value: "4.3 / 5", label: "Müşteri Puanı" },
  { value: "Pzt–Cmt", label: "08:00 – 19:00 Hizmette" },
];

export const SERVICES = [
  {
    key: "kaporta",
    title: "Oto Kaporta & Şasi Onarımı",
    desc: "Kaza ve hasar sonrası ölçümlü şasi düzeltme ve aracın orijinal formuna uygun hassas kaporta işçiliği.",
    badge: "Uzman İşçilik",
  },
  {
    key: "boya",
    title: "Fırınlı Oto Boya",
    desc: "Dijital renk kodlama ile tozsuz fırın kabininde, aracınızın fabrika rengine birebir uyumlu boya uygulaması.",
    badge: "Fırınlı Kabin",
  },
  {
    key: "mekanik",
    title: "Mekanik Bakım & Tamir",
    desc: "Motor, fren, süspansiyon ve triger başta olmak üzere tüm mekanik aksamların kontrolü ve tamiri.",
    badge: "Kapsamlı Kontrol",
  },
  {
    key: "elektrik",
    title: "Oto Elektrik & Teşhis",
    desc: "Akü, alternatör, aydınlatma, tesisat ve elektronik kontrol ünitelerinde arıza tespiti ve onarım.",
    badge: "Hızlı Çözüm",
  },
  {
    key: "mobil",
    title: "Mobil Onarım & Yol Yardım",
    desc: "Yolda kaldığınız anlarda yerinde müdahale, akü takviyesi ve çekici yönlendirme desteği.",
    badge: "Yerinde Müdahale",
  },
  {
    key: "gocuk",
    title: "Boyasız Göçük Onarımı (PDR)",
    desc: "Dolu ve küçük çarpma hasarlarında orijinal boyayı koruyarak özel tekniklerle göçük düzeltme.",
    badge: "Orijinal Boya Korunur",
  },
  {
    key: "cam",
    title: "Cam Tamiri & Değişimi",
    desc: "Çatlak ön cam reçine tamiri; ön, arka ve yan camlarda orijinal standartta değişim ve sızdırmazlık.",
    badge: "Sızdırmazlık Testi",
  },
  {
    key: "plastik",
    title: "Plastik Parça & Tampon Onarımı",
    desc: "Kırık, çatlak ve deforme tampon ile plastik aksamların değişim yerine ekonomik kaynak ve restorasyonu.",
    badge: "Ekonomik Çözüm",
  },
  {
    key: "radyator",
    title: "Radyatör & Soğutma Sistemi",
    desc: "Radyatör sızıntı testi, kaynak ve temizlik; hararet yapmaması için soğutma sistemi bakımı.",
    badge: "Teknik Kontrol",
  },
];

export const REASONS = [
  {
    title: "Şeffaf Süreç & Sürekli Bilgilendirme",
    desc: "İşlem öncesi detaylı ekspertiz ve maliyet bilgilendirmesi; süreç boyunca her adımda haberdarsınız. Onayınız olmadan ek ücret yok.",
  },
  {
    title: "Orijinal Renk & Parça Uyumu",
    desc: "Dijital renk kodlama ile aracınızın fabrika boyasına birebir uyum; kaliteli malzemeyle kalıcı sonuç.",
  },
  {
    title: "Tek Çatı Altında 9 Hizmet",
    desc: "Kaportadan radyatöre, boyasız göçükten cam onarımına kadar tüm ihtiyaçlarınız 1.026 m² kapalı atölyemizde.",
  },
  {
    title: "Güler Yüzlü Hizmet & Temiz Teslimat",
    desc: "Müşteri yorumlarımızda en çok öne çıkan iki şey: özenli işçilik ve pırıl pırıl teslimat.",
  },
];

export const REVIEWS = [
  {
    name: "Ramazan Ö.",
    source: "Google Yorumu",
    comment:
      "Kaza sonrası sürecin her adımında tarafımıza detaylı bilgilendirme yapıldı. İşlem bitince aracı pırıl pırıl teslim ettiler.",
    rating: 5,
  },
  {
    name: "İbrahim B.",
    source: "Google Yorumu",
    comment:
      "Güler yüzlü hizmet ve temiz teslimat. Adana'da işini güvenle yaptırabileceğiniz bir servis.",
    rating: 5,
  },
];

export const RATING = {
  score: "4.3",
  label: "Google & Yandex üzerinden ortalama müşteri puanı",
};

export const GALLERY_CATEGORIES = ["Tümü", "Kaporta & Boya", "Mekanik", "Atölyemiz"];

export const GALLERY = [
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/ddcae6b43fedbc44_Screenshot_20261019_224217_Instagram_1.jpg",
    cat: "Kaporta & Boya",
    caption: "Önce / Sonra: Mercedes A Serisi",
    tall: true,
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/0e0ad3f216842db4_Screenshot_20261019_224349_Instagram.jpg",
    cat: "Atölyemiz",
    caption: "Servis Salonumuz",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/ff5ce2f9fe35f82e_Screenshot_20261019_224358_Instagram.jpg",
    cat: "Atölyemiz",
    caption: "Seyhan'daki Tesisimiz",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/a367a89c6b34c3c2_Screenshot_20261019_225310_Instagram.jpg",
    cat: "Atölyemiz",
    caption: "Teslim Öncesi Araçlar",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/fcf6f0bde3fd0d36_Screenshot_20261019_225418_Instagram.jpg",
    cat: "Atölyemiz",
    caption: "HDI Hızlı Destek Servisi",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/23fa7c2df2d6755c_Screenshot_20261019_225429_Instagram.jpg",
    cat: "Atölyemiz",
    caption: "Auto Life Center Teskimiz",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/e47ffa3574ab998e_Screenshot_20261019_225440_Instagram.jpg",
    cat: "Atölyemiz",
    caption: "Servis Salonu",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/18f8faea8ef91e5f_Screenshot_20261019_225523_Instagram.jpg",
    cat: "Atölyemiz",
    caption: "Gece Servis Girişi",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/2c6216779103dc94_Screenshot_20261019_225508_Instagram.jpg",
    cat: "Atölyemiz",
    caption: "Teslim: Porsche Cayenne",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/3b2f5e115f0276cc_Screenshot_20261019_231529_Instagram.jpg",
    cat: "Atölyemiz",
    caption: "Teslim: Range Rover Sport",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/f5014c0062fe6a47_Screenshot_20261019_231517_Instagram.jpg",
    cat: "Atölyemiz",
    caption: "Serviste: Peugeot 3008",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/95cc58eeacb703b2_Screenshot_20261019_231505_Instagram.jpg",
    cat: "Atölyemiz",
    caption: "Serviste: Mercedes Vito",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/9959d0807f86af18_Screenshot_20261019_231328_Instagram.jpg",
    cat: "Atölyemiz",
    caption: "Teslim Öncesi: Civic & Audi",
  },
  {
    src: "https://images.unsplash.com/photo-1786489785813-8057d678d91e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBjYXIlMjBib2R5JTIwcGFpbnQlMjBkZXRhaWxpbmclMjBnYXJhZ2UlMjBzaG9wfGVufDB8fHx8MTc5MjQyMTI1MHww&ixlib=rb-4.1.0&q=85",
    cat: "Kaporta & Boya",
    caption: "Kaporta Düzeltme",
  },
  {
    src: "https://images.pexels.com/photos/30250199/pexels-photo-30250199.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    cat: "Kaporta & Boya",
    caption: "Fırınlı Boya Kabini",
  },
  {
    src: "https://images.pexels.com/photos/37809560/pexels-photo-37809560.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    cat: "Kaporta & Boya",
    caption: "Boya Sonrası Cila",
  },
  {
    src: "https://images.pexels.com/photos/8986105/pexels-photo-8986105.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    cat: "Mekanik",
    caption: "Bilgisayalı Arıza Tespiti",
  },
  {
    src: "https://images.pexels.com/photos/36044141/pexels-photo-36044141.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    cat: "Mekanik",
    caption: "Fren & Süspansiyon Bakımı",
  },
  {
    src: "https://images.unsplash.com/photo-1642948818738-abe307b53bc6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBsdXh1cnklMjBjYXIlMjBib2R5JTIwcGFpbnQlMjBkZXRhaWxpbmclMjBnYXJhZ2UlMjBzaG9wfGVufDB8fHx8MTc5MjQyMTI1MHww&ixlib=rb-4.1.0&q=85",
    cat: "Atölyemiz",
    caption: "Temiz & Düzenli Atölye",
  },
  {
    src: "https://images.unsplash.com/photo-1610092708835-af669294f3f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjBjYXIlMjBib2R5JTIwcGFpbnQlMjBkZXRhaWxpbmclMjBnYXJhZ2UlMjBzaG9wfGVufDB8fHx8MTc5MjQyMTI1MHww&ixlib=rb-4.1.0&q=85",
    cat: "Atölyemiz",
    caption: "Atölyeden Bir Kare",
  },
  {
    src: "https://images.pexels.com/photos/33814735/pexels-photo-33814735.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    cat: "Atölyemiz",
    caption: "Servis Alanı",
  },
];

export const HERO_IMAGE =
  "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/0e0ad3f216842db4_Screenshot_20261019_224349_Instagram.jpg";

export const SERVICE_OPTIONS = [
  "Kaporta & Şasi Onarımı",
  "Fırınlı Oto Boya",
  "Mekanik Bakım & Tamir",
  "Oto Elektrik & Teşhis",
  "Mobil Onarım & Yol Yardım",
  "Boyasız Göçük Onarımı (PDR)",
  "Cam Tamiri & Değişimi",
  "Plastik Parça & Tampon Onarımı",
  "Radyatör & Soğutma Sistemi",
  "Diğer",
];

export const INSTAGRAM_PHOTOS = [
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/3b2f5e115f0276cc_Screenshot_20261019_231529_Instagram.jpg",
    caption: "Teslim: Range Rover Sport",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/f5014c0062fe6a47_Screenshot_20261019_231517_Instagram.jpg",
    caption: "Serviste: Peugeot 3008",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/95cc58eeacb703b2_Screenshot_20261019_231505_Instagram.jpg",
    caption: "Serviste: Mercedes Vito",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/9959d0807f86af18_Screenshot_20261019_231328_Instagram.jpg",
    caption: "Teslim Öncesi: Civic & Audi",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/2c6216779103dc94_Screenshot_20261019_225508_Instagram.jpg",
    caption: "Teslim: Porsche Cayenne",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_oto-sistem/artifacts/18f8faea8ef91e5f_Screenshot_20261019_225523_Instagram.jpg",
    caption: "Gece Servis Girişi",
  },
];

export const isOpenNow = () => {
  const now = new Date();
  const day = now.getDay();
  const hour = now.getHours();
  return day !== 0 && hour >= 8 && hour < 19;
};
